import { DividerType, Label, Wrapper } from './Divider.ui';

type DividerProps = {
  label?: React.ReactNode;
  className?: string;
  type?: DividerType;
};

export const Divider = ({ label, className }: DividerProps) => (
  <Wrapper className={className}>
    {typeof label === 'string' ? <Label>{label}</Label> : label}
  </Wrapper>
);
